import Cookies from "js-cookie";

const KEY = "browser_id";

function generate(): string {
  const id = crypto.randomUUID();
  Cookies.set(KEY, id);
  return id;
}

export function getBrowserId(): string {
  return Cookies.get(KEY) ?? generate();
}

export function regenerateBrowserId(): string {
  return generate();
}
